import { NodeUI } from 'modules/workflows/components/Node/types'
import ConditionalNodeSidepanel from 'modules/workflows/components/Sidepanel/ConditionalNodeSidepanel/index'
import TaskNodeSidepanel from 'modules/workflows/components/Sidepanel/TaskNodeSidepanel'
import TriggerNodeSidepanel from 'modules/workflows/components/Sidepanel/TriggerNodeSidepanel'
import { VariablesConfig } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'
import {
  BuildingBlock,
  WorkflowBuildingBlocksBox,
} from 'modules/workflows/components/WorkflowBuildingBlocksBox'

import { ApprovalNodeSidepanel } from './ApprovalNodeSidepanel'
import { SidePanelFormProvider } from './SidePanelFormProvider'

type Props = {
  showBuildingBlock: boolean
  selectedNode: NodeUI | undefined
  buildingBlocks: BuildingBlock[]
  variablesConfig: VariablesConfig
}
export const Sidepanel = ({
  showBuildingBlock,
  selectedNode,
  buildingBlocks,
  variablesConfig,
}: Props) => {
  return (
    <>
      {showBuildingBlock && <WorkflowBuildingBlocksBox buildingBlocks={buildingBlocks} />}

      {selectedNode && (
        <SidePanelFormProvider
          variablesConfig={variablesConfig}
          selectedNode={selectedNode}
          key={selectedNode.id}
        >
          {selectedNode.type === 'trigger' && (
            <TriggerNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
          {selectedNode.type === 'condition' && (
            <ConditionalNodeSidepanel
              key={selectedNode.id}
              node={selectedNode}
              variablesConfig={variablesConfig}
            />
          )}
          {selectedNode.type === 'approvals' && (
            <ApprovalNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
          {selectedNode.type === 'task' && (
            <TaskNodeSidepanel key={selectedNode.id} node={selectedNode} />
          )}
        </SidePanelFormProvider>
      )}
    </>
  )
}
